var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 190",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 190,
    width: 400
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#b2ebf9",
    cx: 125,
    r: 50,
    cy: 130
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#aea1ea",
    cx: 85,
    r: 40,
    cy: 80
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#8c54a1",
    cx: 130,
    r: 30,
    cy: 40
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(100, 75)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 354,
    height: 74
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Helvetica Neue, sans-serif",
    fontSize: 80,
    fontWeight: 500,
    fill: "#252b33"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 58
  }, "Jaconn"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6bfbe0a77714108c00e482aec5c57d61.svg";
export { ForwardRef as ReactComponent };